import KH from "../../assets/images/result/KH.jpg";
import KP_DAY from "../../assets/images/result/KP-Day.jpg";
import KP_NIGHT from "../../assets/images/result/KP-Night.jpg";
import KP_DAY_MC from "../../assets/images/result/KP-Day-MC.jpg";
import KP_NIGHT_MC from "../../assets/images/result/KP-Night-MC.jpg";
import MC_DAY from "../../assets/images/result/MC-Day.jpg";
import MC_NIGHT from "../../assets/images/result/MC-Night.jpg";
import LEAP from "../../assets/images/result/MHSB.jpg";
import MT_DAY from "../../assets/images/result/MT-Day.jpg";
import MT_NIGHT from "../../assets/images/result/MT-Night.jpg";
import SC from "../../assets/images/result/SC.jpg";
import TC_DAY from "../../assets/images/result/TC-Day.jpg";
import TC_NIGHT from "../../assets/images/result/TC-Night.jpg";

export const RESULT_BACKGROUNDS = {
    MC: { DAY: MC_DAY, NIGHT: MC_NIGHT },
    KP: { DAY: KP_DAY, NIGHT: KP_NIGHT },
    KP_MC: { DAY: KP_DAY_MC, NIGHT: KP_NIGHT_MC },
    MT: { DAY: MT_DAY, NIGHT: MT_NIGHT },
    TC: { DAY: TC_DAY, NIGHT: TC_NIGHT },
    KH,
    SC,
    LEAP,
    DEFAULT: { DAY: MC_DAY, NIGHT: MC_NIGHT },
};

// S3 brands use explicit MT filenames for regular KP draws.
// P99 retains the original bundled filenames above.
export const RESULT_FILENAMES = {
    MC: { DAY: "MC-Day.jpg", NIGHT: "MC-Night.jpg" },
    KP: { DAY: "KP-Day-MT.jpg", NIGHT: "KP-Night-MT.jpg" },
    KP_MC: { DAY: "KP-Day-MC.jpg", NIGHT: "KP-Night-MC.jpg" },
    MT: { DAY: "MT-Day.jpg", NIGHT: "MT-Night.jpg" },
    TC: { DAY: "TC-Day.jpg", NIGHT: "TC-Night.jpg" },
    KH: "KH.jpg",
    SC: "SC.jpg",
    LEAP: "MHSB.jpg",
    DEFAULT: { DAY: "MC-Day.jpg", NIGHT: "MC-Night.jpg" },
};

const RESULT_ASSET_ROOT = "https://vnonemedia.s3.ap-southeast-1.amazonaws.com/lottery-live-poster";

export function normalizeResultBrand(brand = "p99") {
    return String(brand).toLowerCase();
}

// Accept any brand folder name without allowing URL or path separators.
export function isValidResultBrand(brand) {
    return /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/.test(normalizeResultBrand(brand));
}

export function getBrandResultBackground(lotteryType, mode, brand = "p99") {
    const normalizedBrand = normalizeResultBrand(brand);
    if (!isValidResultBrand(normalizedBrand)) {
        throw new Error(`Invalid result brand: ${brand}`);
    }
    const type = String(lotteryType || "").toUpperCase();
    const assets = normalizedBrand === "p99" ? RESULT_BACKGROUNDS : RESULT_FILENAMES;
    const entry = assets[type] || assets.DEFAULT;
    const image = entry[mode] || entry;
    return normalizedBrand === "p99" ? image : `${RESULT_ASSET_ROOT}/${normalizedBrand}/${image}`;
}

export const RESULT_RATIOS = {
    MC: { DAY: "467 / 721", NIGHT: "467 / 721" },
    MT: { DAY: "467 / 721", NIGHT: "467 / 721" },
    TC: { DAY: "467 / 721", NIGHT: "467 / 721" },
    KP: { DAY: "1074 / 1530", NIGHT: "971 / 1500" },
    KH: "702 / 878",
    SC: "702 / 960",
    LEAP: "702 / 960",
    DEFAULT: { DAY: "467 / 721", NIGHT: "467 / 721" },
};
